var map = {
	"./template.betgalaxy": 2061,
	"./template.betgalaxy.tsx": 2061,
	"./template.betprofessor": 1137,
	"./template.betprofessor.tsx": 1137,
	"./template.betroyale": 1138,
	"./template.betroyale.tsx": 1138,
	"./template.default": 660,
	"./template.default.tsx": 660,
	"./template.fiestabet": 1139,
	"./template.fiestabet.tsx": 1139,
	"./template.puntcity": 1140,
	"./template.puntcity.tsx": 1140,
	"./template.puntgenie": 1141,
	"./template.puntgenie.tsx": 1141,
	"./template.questbet": 1142,
	"./template.questbet.tsx": 1142,
	"./template.ts": 971,
	"./template.volcanobet": 1143,
	"./template.volcanobet.tsx": 1143,
	"./template.wellbet": 1144,
	"./template.wellbet.tsx": 1144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2430;